import React, {
  useState,
  useEffect,
  useRef,
  useContext,
} from "react";

import { useNavigate } from "react-router-dom";

import labVideo from "../assets/videos/lab_video.mp4";

import Timer from "./Timer";

import {
  sendOtp,
  verifyOtp,
} from "../../services/SignIn/authApi";

import { UserContext } from "../../context/UserContext";

import {
  requestPermission,
  listenMessages,
} from "../../firebase/messaging";

import { toast } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";

import appStoreImg from "../../component/assets/logo/appstore.png";

export default function SignIn() {

  const { loginUser } = useContext(UserContext);

  const navigate = useNavigate();

  const [canEdit, setCanEdit] =
    useState(false);

  const [identifier, setIdentifier] =
    useState("");

  const [otp, setOtp] = useState([
    "",
    "",
    "",
    "",
    "",
    "",
  ]);

  const [error, setError] =
    useState("");

  const [success, setSuccess] =
    useState("");

  const [loading, setLoading] =
    useState(false);

  const [isOtpSent, setIsOtpSent] =
    useState(false);

  const [timeLeft, setTimeLeft] =
    useState(0);

  const firstOtpRef = useRef(null);

  // ======================================
  // 🔥 FOCUS OTP
  // ======================================
  useEffect(() => {

    if (
      isOtpSent &&
      firstOtpRef.current
    ) {
      firstOtpRef.current.focus();
    }

  }, [isOtpSent]);

  // ======================================
  // 🔥 LISTEN NOTIFICATIONS
  // ======================================
  useEffect(() => {

    const unsubscribe =
      listenMessages((payload) => {

        console.log(
          "📩 Notification:",
          payload
        );

        const title =
          payload?.title ||
          payload?.notification?.title ||
          "Notification";

        const body =
          payload?.body ||
          payload?.notification?.body ||
          "";

        toast.info(
          `${title} - ${body}`
        );
      });

    return () => {
      if (unsubscribe) unsubscribe();
    };

  }, []);

  // ======================================
  // 🔥 OTP INPUT
  // ======================================
  const handleOtpChange = (
    value,
    index
  ) => {

    if (!/^[0-9]?$/.test(value))
      return;

    const updatedOtp = [...otp];

    updatedOtp[index] = value;

    setOtp(updatedOtp);

    // NEXT INPUT
    if (value && index < 5) {

      document
        .getElementById(
          `otp-${index + 1}`
        )
        ?.focus();

    }

    // PREVIOUS INPUT
    else if (
      !value &&
      index > 0
    ) {

      document
        .getElementById(
          `otp-${index - 1}`
        )
        ?.focus();

    }
  };

  // ======================================
  // 🔥 SEND OTP
  // ======================================
  const handleSendOtp = async (
    e
  ) => {

    e.preventDefault();

    setError("");

    setSuccess("");

    const input =
      identifier.trim();

    if (!input) {

      setError(
        "Enter email or phone."
      );

      return;
    }

    try {

      setLoading(true);

      const res =
        await sendOtp(input);

      setLoading(false);

      if (res?.success) {

        // ✅ SUCCESS MESSAGE - COMMENT KAR DIYA
        // setSuccess(res.success);

        setIsOtpSent(true);

        setTimeLeft(30);

        setOtp([
          "",
          "",
          "",
          "",
          "",
          "",
        ]);

      } else {

        setError(
          res?.error ||
            "Failed to send OTP."
        );

      }

    } catch (err) {

      console.log(
        "❌ SEND OTP ERROR:",
        err
      );

      setLoading(false);

      setError(
        "Something went wrong."
      );
    }
  };

  // ======================================
  // 🔥 VERIFY OTP
  // ======================================
  // ======================================
  // 🔥 VERIFY OTP
  // ======================================
  const handleVerifyOtp = async (e) => {

    e.preventDefault();

    setError("");
    setSuccess("");

    const input = identifier.trim();

    const enteredOtp = otp.join("");

    console.log("=================================");
    console.log("🔥 VERIFY OTP STARTED");
    console.log("📱 IDENTIFIER:", input);
    console.log("🔢 ENTERED OTP:", enteredOtp);
    console.log("=================================");

    // ✅ VALIDATION
    if (
      enteredOtp.length !== 6 ||
      otp.includes("")
    ) {

      console.log("❌ OTP VALIDATION FAILED");

      setError(
        "Enter full 6-digit OTP."
      );

      return;
    }

    try {

      setLoading(true);

      console.log("📡 CALLING VERIFY OTP API...");

      const res = await verifyOtp(
        input,
        enteredOtp
      );

      console.log("✅ VERIFY API RESPONSE:", res);

      setLoading(false);

      // ======================================
      // ✅ SUCCESS
      // ======================================
      if (res?.success) {

        console.log("✅ OTP VERIFIED SUCCESSFULLY");

        // ======================================
        // 🔥 GET FCM TOKEN
        // ======================================
        let fcmToken = "";

        try {

          console.log("=================================");
          console.log("🔥 REQUESTING FCM TOKEN...");
          console.log("=================================");

          fcmToken =
            await requestPermission();

          console.log("=================================");
          console.log("✅ FCM TOKEN RECEIVED:");
          console.log(fcmToken);
          console.log("=================================");

          // ✅ LOCAL STORAGE CHECK
          console.log(
            "💾 LOCAL STORAGE TOKEN:",
            localStorage.getItem("fcmToken")
          );

        } catch (err) {

          console.log(
            "❌ FCM TOKEN ERROR:",
            err
          );
        }

        // ======================================
        // 🔥 USER DATA
        // ======================================
        const userData = {

          identifier: input,

          userId:
            res?.user?.id,

          token:
            res?.token,

          loginTime:
            new Date().toLocaleString(),

          fcmToken:
            fcmToken || "",

        };

        console.log("=================================");
        console.log("✅ FINAL USER DATA:");
        console.log(userData);
        console.log("=================================");

        // ======================================
        // 🔥 LOGIN USER
        // ======================================
        console.log("📡 CALLING loginUser()");

        loginUser(userData);

        console.log("✅ loginUser COMPLETED");

        // ======================================
        // 🔥 CHECK LOCAL STORAGE
        // ======================================
        setTimeout(() => {

          console.log("=================================");
          console.log("💾 STORAGE DEBUG");
          console.log("=================================");

          console.log(
            "USER:",
            localStorage.getItem("user")
          );

          console.log(
            "FCM TOKEN:",
            localStorage.getItem("fcmToken")
          );

          console.log("=================================");

        }, 500);

        // ======================================
        // 🔥 SUCCESS TOAST
        // ======================================
        toast.success(
          "OTP Verified Successfully"
        );

        // ======================================
        // 🔥 REDIRECT
        // ======================================
        setTimeout(() => {

          console.log(
            "🚀 REDIRECTING TO HOME"
          );

          navigate("/");

        }, 1000);

      }

      // ======================================
      // ❌ INVALID OTP
      // ======================================
      else {

        console.log(
          "❌ INVALID OTP RESPONSE"
        );

        setError(
          res?.error ||
          "Invalid OTP. Try again."
        );

      }

    }

    // ======================================
    // ❌ ERROR
    // ======================================
    catch (err) {

      console.log(
        "================================="
      );

      console.log(
        "❌ VERIFY OTP ERROR:"
      );

      console.log(err);

      console.log(
        "================================="
      );

      setLoading(false);

      setError(
        "Something went wrong."
      );
    }
  };
  return (

    <div className="h-screen w-full overflow-hidden bg-white">

      <div className="grid md:grid-cols-2 h-screen">

        {/* LEFT VIDEO */}
        <div className="hidden md:block h-screen">

          <video
            autoPlay
            loop
            muted
            playsInline
            src={labVideo}
            className="w-full h-full object-cover"
          />

        </div>

        {/* RIGHT FORM */}
        <div className="flex items-center justify-center h-screen p-8 relative">

          {/* SKIP */}
          <button
            onClick={() =>
              navigate("/")
            }
            className="absolute top-4 right-6 text-sm text-gray-600 hover:text-red-600 font-medium"
          >
            Skip →
          </button>

          <div className="w-full max-w-md">

            {/* HEADER */}
            <div className="flex flex-col items-center mb-6">

              <img
                src={appStoreImg}
                alt="logo"
                className="w-32 h-30"
              />

              <h2 className="text-2xl font-bold text-red-600">
                Sign in to Medrpha Lab
              </h2>

            </div>

            {/* ======================================
                🔥 SEND OTP FORM
            ====================================== */}
            {!isOtpSent ? (

              <form
                onSubmit={
                  handleSendOtp
                }
                className="space-y-4"
              >

                <input
                  type="text"
                  className="w-full px-3 py-2 border rounded-md outline-none"
                  placeholder="Email or Phone"
                  value={identifier}
                  onChange={(e) =>
                    setIdentifier(
                      e.target.value
                    )
                  }
                />

                {error && (
                  <p className="text-red-500 text-sm">
                    {error}
                  </p>
                )}

                {/* ✅ SUCCESS MESSAGE - COMMENT KAR DIYA */}
                {/* {success && (
                  <p className="text-green-500 text-sm">
                    {success}
                  </p>
                )} */}

                <button
                  type="submit"
                  disabled={loading}
                  className="w-full bg-red-600 text-white py-2 rounded-md"
                >
                  {loading
                    ? "Sending OTP..."
                    : "Send OTP"}
                </button>

              </form>

            ) : (

              /* ======================================
                  🔥 VERIFY OTP FORM
              ====================================== */
              <form
                onSubmit={
                  handleVerifyOtp
                }
                className="space-y-4"
              >

                <div className="text-center text-sm text-gray-600">

                  OTP sent to{" "}

                  <b>
                    {identifier}
                  </b>

                  <button
                    type="button"
                    onClick={() => {

                      setIsOtpSent(
                        false
                      );

                      setOtp([
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                      ]);

                      setError("");

                      setSuccess("");

                      setCanEdit(
                        true
                      );
                    }}
                    className="ml-2 text-red-600 underline text-xs"
                  >
                    Edit
                  </button>

                </div>

                {/* OTP BOXES */}
                <div className="flex gap-2">

                  {otp.map(
                    (
                      digit,
                      index
                    ) => (

                      <input
                        key={index}
                        id={`otp-${index}`}
                        ref={
                          index === 0
                            ? firstOtpRef
                            : null
                        }
                        type="text"
                        maxLength="1"
                        value={digit}
                        onChange={(e) =>
                          handleOtpChange(
                            e.target
                              .value,
                            index
                          )
                        }
                        className="w-full h-12 border text-center rounded-md outline-none"
                      />

                    )
                  )}

                </div>

                {error && (
                  <p className="text-red-500 text-sm">
                    {error}
                  </p>
                )}

                {/* ✅ SUCCESS MESSAGE - COMMENT KAR DIYA */}
                {/* {success && (
                  <p className="text-green-500 text-sm">
                    {success}
                  </p>
                )} */}

                {/* TIMER */}
                {timeLeft > 0 ? (

                  <Timer
                    timeLeft={
                      timeLeft
                    }
                    setTimeLeft={
                      setTimeLeft
                    }
                  />

                ) : (

                  <button
                    type="button"
                    onClick={
                      handleSendOtp
                    }
                    className="text-red-600 text-sm underline"
                  >
                    Resend OTP
                  </button>

                )}

                {/* VERIFY BUTTON */}
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full bg-red-600 text-white py-2 rounded-md"
                >
                  {loading
                    ? "Verifying..."
                    : "Verify OTP"}
                </button>

              </form>

            )}

          </div>

        </div>

      </div>

    </div>
  );
}